import { UnifiedIcon } from '@/components/UnifiedIcon';
import {
  LOGIN_SHOWCASE_AGENT_PREVIEWS,
  LOGIN_SHOWCASE_FEATURES,
} from '@/views/login/loginShowcaseContent';

/**
 * Left / hero panel: animated gradient + agent platform value props (desktop split).
 */
export function LoginShowcasePanel() {
  return (
    <aside
      data-testid="agents-login-showcase"
      className="agents-login-showcase relative flex h-full min-h-0 flex-col justify-center gap-4 overflow-hidden p-5 sm:p-6 lg:gap-5 lg:px-8 lg:py-6"
      aria-hidden={false}
    >
      <div className="agents-login-gradient-layer" aria-hidden />
      <div className="agents-login-orb agents-login-orb-a" aria-hidden />
      <div className="agents-login-orb agents-login-orb-b" aria-hidden />
      <div className="agents-login-orb agents-login-orb-c" aria-hidden />
      <div className="agents-login-grid-overlay" aria-hidden />

      <div className="relative z-10 shrink-0">
        <div className="mb-3 inline-flex items-center gap-1.5 rounded-full border border-white/15 bg-white/10 px-2.5 py-0.5 text-[10px] font-medium uppercase tracking-widest text-white/90 backdrop-blur-md lg:text-xs">
          <UnifiedIcon name="Robot" size={14} weight="duotone" className="h-3.5 w-3.5" />
          Kincode Agents
        </div>

        <h2 className="max-w-md text-2xl font-semibold leading-tight tracking-tight text-white sm:text-[1.65rem] lg:max-w-lg lg:text-3xl">
          Build agents that work while you sleep
        </h2>
        <p className="mt-2 max-w-sm text-sm leading-snug text-white/75 lg:mt-2.5 lg:max-w-md">
          Automation with guardrails, connectors, and measurable outcomes.
        </p>
      </div>

      <div
        data-testid="agents-login-showcase-features"
        className="relative z-10 hidden shrink-0 grid-cols-2 gap-2 lg:grid"
      >
        {LOGIN_SHOWCASE_FEATURES.map((feature) => (
          <div
            key={feature.title}
            className="agents-login-feature-card flex gap-2.5 rounded-kc-sm border border-white/10 bg-white/5 p-2.5 backdrop-blur-md"
          >
            <div className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-kc-sm bg-white/10 text-white">
              <UnifiedIcon name={feature.icon} size={16} weight="duotone" className="h-4 w-4" />
            </div>
            <div className="min-w-0">
              <h3 className="text-xs font-semibold text-white">{feature.title}</h3>
              <p className="mt-0.5 line-clamp-2 text-[11px] leading-snug text-white/60">
                {feature.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div
        data-testid="agents-login-showcase-previews"
        className="relative z-10 hidden shrink-0 gap-2 lg:grid lg:grid-cols-2"
      >
        {LOGIN_SHOWCASE_AGENT_PREVIEWS.map((preview, index) => (
          <div
            key={preview.label}
            className={`agents-login-preview-card rounded-kc-sm border border-white/10 bg-white/5 px-3 py-2 backdrop-blur-md ${
              index === 0 ? 'agents-login-preview-float-a' : 'agents-login-preview-float-b'
            }`}
          >
            <div className="flex items-center justify-between gap-2">
              <div className="min-w-0">
                <p className="text-[10px] font-medium uppercase tracking-wide text-white/50">
                  {preview.label}
                </p>
                <p className="truncate text-xs text-white/90">{preview.task}</p>
              </div>
              <span
                className={`shrink-0 rounded-full px-1.5 py-px font-mono text-[9px] font-medium uppercase tracking-wide ${
                  preview.status === 'running'
                    ? 'bg-emerald-400/20 text-emerald-200'
                    : 'bg-sky-400/20 text-sky-200'
                }`}
              >
                {preview.status}
              </span>
            </div>
          </div>
        ))}
      </div>
    </aside>
  );
}
